module.exports = __webpack_public_path__ + "static/media/fi.2649533e.svg";